"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsx jsx */
const react_1 = require("@emotion/react");
const react_redux_1 = require("react-redux");
const b_1 = __importDefault(require("b_"));
const i18n_1 = __importDefault(require("@yandex-int/pythia-libs/lib/i18n"));
const selectors_1 = require("src/redux/sagas/selectors");
const scope_1 = require("src/hooks/scope");
const footer_styles_1 = __importDefault(require("./footer.styles"));
const b = b_1.default.with('footer');
const now = new Date();
const getTankerKey = (host) => (host === 'odna.co' ? 'odnaco' : 'default');
const createLinkObj = (i18n) => (name, withLogo = false) => ({
    name,
    url: i18n([name, 'url']),
    text: i18n([name, 'text']),
    withLogo
});
function getFooterElements(i18n, internal) {
    const create = createLinkObj(i18n);
    return internal ? {
        links: [create('confidential'), create('createby', true)],
        responsibilityLabel: i18n(['internalSurvey']),
        copyright: i18n(['copyrightInternal', 'text']).replace('%s', String(now.getFullYear()))
    } : {
        links: [create('confpolicy'), create('termsofuse')],
        responsibilityLabel: i18n(['responsibility']),
        copyright: i18n(['copyright', 'text']).replace('%s', String(now.getFullYear()))
    };
}
// eslint-disable-next-line max-statements
function useFooterElements(i18n) {
    const isInited = (0, react_redux_1.useSelector)((state) => state.survey.inited);
    const internal = (0, scope_1.useIsInternalSurvey)();
    let links = [];
    let responsibilityLabel = '';
    let copyright;
    if (isInited) {
        const elements = getFooterElements(i18n, internal);
        links = elements.links;
        responsibilityLabel = elements.responsibilityLabel;
        copyright = elements.copyright;
    }
    return [links, responsibilityLabel, copyright];
}
// eslint-disable-next-line max-statements, complexity
function Footer({ legalText, footerLinks }) {
    const host = (0, react_redux_1.useSelector)((state) => (0, selectors_1.getLocation)(state).host);
    const i18n = (0, i18n_1.default)(['footer', getTankerKey(host)]);
    const [links, responsibilityLabel, copyright] = useFooterElements(i18n);
    const renderedLinks = footerLinks || links;
    const footerText = legalText || responsibilityLabel;
    return ((0, jsx_runtime_1.jsxs)("footer", Object.assign({ className: b() }, { children: [(0, jsx_runtime_1.jsx)(react_1.Global, { styles: footer_styles_1.default }), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: b('links') }, { children: renderedLinks.map(item => ((0, jsx_runtime_1.jsxs)("a", Object.assign({ className: b('link'), href: item.url, target: '_blank', rel: 'noreferrer' }, { children: [item.text, item.withLogo && ((0, jsx_runtime_1.jsx)("img", { src: 'https://yastatic.net/s3/distribution/pythia/poll/_/favicon-32x32.png' }))] }), item.url))) })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: b('legal') }, { children: (0, jsx_runtime_1.jsxs)("div", { children: [footerText, " ", !legalText && copyright] }) }))] })));
}
exports.default = Footer;
